<template>
  <!-- Messages area -->
  <div
    class="flex-grow overflow-y-scroll h-0 text-white"
    @scroll="scrollingOnMessagesArea"
    ref="messagesArea"
  >
    <!-- Messages list -->
    <div class="flex flex-col max-h-full w-full">
      <div class="p-4 mb-5">
        <ChatMessage
          v-for="messageData in messagesData"
          :key="messageData.id"
          :message-data="messageData"
          :clinicianName="clinicianName"
          :user-id="userId"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChatMessage from './ChatMessage.vue';

export default {
  props: {
    messagesData: {
      required: false,
    },
    userId: {
      required: true,
    },
    clinicianName: {
      type: String,
    },
  },
  components: {
    ChatMessage,
  },
  mounted() {
    this.scrollToLastMessage(true);
  },
  data() {
    return {
      userIsScrolling: false,
      showNewMessagesIndicator: false,
    };
  },

  watch: {
    messagesData: {
      deep: true,
      handler() {
        this.scrollToLastMessage();
      },
    },
  },
  methods: {
    scrollingOnMessagesArea(event) {
      const posFromBottom =
        event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
      this.userIsScrolling = posFromBottom > 200;
      if (posFromBottom < 20) {
        this.showNewMessagesIndicator = false;
      }
    },

    scrollToLastMessage(forced = false) {
      const messageArea = this.$refs.messagesArea;
      if (!messageArea) return;

      if (!this.userIsScrolling || forced) {
        messageArea.scrollTo({
          top: messageArea.scrollHeight,
          behavior: 'smooth',
        });
        setTimeout(() => {
          messageArea.scrollTo({
            top: messageArea.scrollHeight,
            behavior: 'smooth',
          });
          this.showNewMessagesIndicator = false;
        }, 300);
      } else {
        this.showNewMessagesIndicator = true;
      }
    },
  },
};
</script>

<style></style>
